<template>
  <div id="app">
    <CimavillaInfo :msg="pageInfo" />
  </div>
</template>

<script>
import CimavillaInfo from './components/CimavillaInfo.vue'

export default {
  name: 'App',
  components: {
    CimavillaInfo
  },
  data: function() {
    return {
      pageInfo: "this is a test from me"
    };
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
